import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import DeletePopup from '../../../../GardenPopup/DeletePopup'
import Header from '../../../../../../../Components/Header/Header'
import Sidebar from '../../../../../../../Components/Sidebar/Sidebar'
import SeweragePipelinePopup from './SeweragePipelinePopup'
import { WardNameDataDDL } from '../../../../../../../Components/CommonDDL/WardNameDataDDL'
import { useAuthState } from '../../../../../../../Helper/Context'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { SeverageLocationDataDDL } from '../../../../../../../Components/CommonDDL/SeverageLocationDataDDL'
import { SeveragePipelineDetailsMasterDeleteAPI, SeveragePipelineDetailsMasterTableDataAPI } from '../../../../../../../Redux/SeverageDashboardSlice/SeveragePipelineDetailsMaster'
import { Pegination } from '../../../../../../../Components/Pegination/Pegination'
import { Loading } from '../../../../../../../Helper/Loading'

export default function SeweragePipelineData() {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails
    const dispatch = useDispatch()

    const [SewerageMasterPopupShow, setSewerageMasterPopupShow] = useState()
    const [DeletePopupShow, setDeletePopupShow] = useState()
    const [ImagePopUpData, setImagePopUpData] = React.useState('')
    const [showImagePopup, setshowImagePopup] = React.useState(false)
    const [From, setFrom] = useState(1)
    const [To, setTo] = useState(10)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [PerPageCount, setPerPageCount] = useState(10)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [rowNo, setrowNo] = useState(1)
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')
    const [ShowMap, setShowMap] = React.useState(false)
    const [LocationData, setLocationData] = React.useState({})

    const [YearValue, setYearValue] = useState(0)

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: HWard && HWard ? HWard : '0',
        Label: WLable && WLable ? WLable : "Select...",
    })
    
    const [SeverageLocation, setSeverageLocation] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setSewerageMasterPopupShow(true)
    }

    const handleEditOnClick = (item) => {
        setSewerageMasterPopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }
    const handleOnCloseClick = () => {
        setSewerageMasterPopupShow(false)
    }

    const handleIsPost = () => {
        setIsPost(!IsPost)
    }

    useEffect(() => {
        setCurrentPage(0)
        setFrom(1)
        setTo(10)
    }, [SeverageLocation.ID, WardName.ID])

    const handleClear = () => {
        setCurrentPage(0)
        setIsClear(!IsClear)
        setSeverageLocation({
            ...SeverageLocation,
            ID: 0,
            Label: 'Select...',
        })
        setWardName({
            ...WardName,
            ID: HWard,
            Label: WLable,
        })
    }

    const handleDeleteApi = (item) => {
        const data = {
            M_SW_PipelineDetailsID: item.m_sW_PipelineDetailsID,
            M_UserID: UserID,
            handleIsPost: handleIsPost,
            token: token,
        }
        dispatch(SeveragePipelineDetailsMasterDeleteAPI({ data }))
    }

    useEffect(() => {
        const data = {

            M_SW_PipelineDetailsID: 0,
            M_WardID: WardName.ID,
            M_SW_LocationID: SeverageLocation.ID,
            PipelineDetail: '',
            M_UserID: UserID,
            From: From,
            To: To,
            token: token,
            // M_GD_SectorID: SectorName.ID,
        }
        dispatch(SeveragePipelineDetailsMasterTableDataAPI({ data }))
    }, [IsPost, To, IsClear, WardName.ID, SeverageLocation.ID])

    const { tableData, isLoading } = useSelector(state => state.SeveragePipelineDetailsMasterTableData)


    // const [SelectWard, setSelectWard] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select...",
    // })

    return (
        <>
            {isLoading && <Loading />}
            {/* {isDeleteLoading && <Loading />} */}
            <div>
                <Header
                    // DashboardHeading="Sewerage Maintainance"
                    DashboardName={DashboardName} 
                    MLable={MLable}
                    HMonth={HMonth}
                    YLable={YLable}
                    HYear={HYear}
                    HWard={HWard}
                    WLable={WLable}
                    flag='Screen'
                />
                <div className="wrapper">
                    <Sidebar ProjectTypeId={ProjectTypeId} />
                    <div className="content">
                        <div className="page-header ">
                            <div className="page-block">
                                <div className="row align-items-center">
                                    <div className="col-md-12">
                                        <div className="page-header-title">
                                            {/* <h5 className="ps-2 data_mob"> */}
                                            {/* <span className="float-end fs-6">
                                            <Select
                                                    // isClearable
                                                    // isRtl={isRtl}
                                                    isSearchable
                                                    maxMenuHeight={150}
                                                    value={{ value: SelectWard.ID, label: SelectWard.Label }}
                                                    onChange={(e) => {
                                                        e ?
                                                            setSelectWard({ ...SelectWard, ID: e.value, Label: e.label })
                                                            :
                                                            setSelectWard({ ...SelectWard, ID: 0, Label: "Select..." })

                                                    }}
                                                    options={SelectWard.DDL}
                                                />
                                            </span> */}
                                            {/* </h5> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='data_mob'>
                            <div className="row m-1 py-1 pb-4 master_border">
                                <div className='col-6'>
                                    <h5 className="ps-1 py-1 ">Pipelines Details Master</h5>
                                </div>
                                <div className='mar_add_minus'>
                                    <div className="float-end butt">
                                        {/* <i class="fa-solid fa-plus add_btn" style={{ color: "#010813", fontSize: '17px' }}><span className="ml-2">Add</span></i> */}
                                        <button type="button" className="btn btn-primary float-end ml-1">Export</button>
                                        {/* 
                                        <SeweragePipelinePopup
                                            open={SewerageMasterPopupShow}
                                        /> */}
                                        <i className="fa-solid fa-plus float-end btn btn-secondary mb-2"
                                            style={{ color: "white" }}
                                            onClick={handleAddOnClick}
                                        >
                                            <text className="ml-2 poppins">Add</text>
                                        </i>
                                    </div>
                                </div>
                                <div>

                                </div>
                                <div className="row m-0 ">
                                    <div className="col-12 py-2 rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                        <div className="col-12  ">
                                            <div className="row  rounded2">

                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <WardNameDataDDL
                                                        WardName={WardName}
                                                        setWardName={setWardName}
                                                        HWard={HWard}
                                                        WLable={WLable}
                                                    />

                                                </div>

                                                <div className="col-12 col-md-4 col-lg-3 ">
                                                    <SeverageLocationDataDDL
                                                        SeverageLocation={SeverageLocation}
                                                        setSeverageLocation={setSeverageLocation}
                                                        WardName={WardName}

                                                    />

                                                </div>

                                                <div className="col-12 col-lg-3 mt-lg-4" >
                                                    <button type="button"
                                                        className="btn-clear btn btn-primary"
                                                        onClick={handleClear}>Clear</button>
                                                </div>
                                            </div>
                                            <div className="row mob_table table-responsive pt-2">
                                                <table id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th className="sr_no_col">Sr No.</th>
                                                            <th>Prabhag No</th>
                                                            <th>Location</th>
                                                            <th>Pipeline Details</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) =>
                                                                <tr>
                                                                    <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                    <td>{item.wardName ? item.wardName : '-'}</td>
                                                                    <td>{item.swLocation ? item.swLocation : '-'}</td>
                                                                    <td>{item.pipelineDetail ? item.pipelineDetail : '-'}</td>
                                                                    <td style={{ textAlign: "center", }}>
                                                                        <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                            style={{ cursor: 'pointer' }}
                                                                            onClick={() => handleEditOnClick(item)}
                                                                        >
                                                                        </i>
                                                                        <DeletePopup
                                                                            open={DeletePopupShow}
                                                                            item={item}
                                                                            handleDeleteApi={handleDeleteApi}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ) :
                                                                <>No Found data</>
                                                        }
                                                    </tbody>
                                                </table>

                                            </div>
                                            {tableData && tableData.table && tableData.table.length > 0 &&
                                                <Pegination
                                                    PerPageCount={PerPageCount}
                                                    TotalCount={tableData.table[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setrowNo}
                                                    CurrentPage={CurrentPage}
                                                    setCurrentPage={setCurrentPage}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div >
                {
                    SewerageMasterPopupShow ?
                        <SeweragePipelinePopup
                            open={SewerageMasterPopupShow}
                            popupHeading="Pipeline Details"
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                        />
                        : <></>
                }

            </div >
        </>
    )
}
